import React, { Component } from 'react';
import './css/contactus-page.css';

class ContactusPage extends Component {
	constructor(props){
		super(props);
		console.log("Contactus()");
		this.state = {
			isLightboxVisible : false,
			dbFields: {},
			lesseeTel: '',
			lesseeEmail: '',
			firstnameInputStatus: '',
			lastnameInputStatus: '',
			telInputStatus: '',
			emailInputStatus: '',
			oemInputStatus: '',
			vinInputStatus: '',
			messageInputStatus: '',
			submitButtonStatus: 'disabled',
			ajaxLoadingState : 'loading'
		};
		this.manageTelInput = this.manageTelInput.bind(this);
		this.manageEmailInput = this.manageEmailInput.bind(this);

		this.validateTelInput = this.validateTelInput.bind(this);
		this.validateEmailInput = this.validateEmailInput.bind(this);

	}

	componentDidMount() {
		//console.log("window.optaToken=", window.optaToken);
		//console.log("window.optaAdminToken=", window.optaAdminToken);
		if (window.optaToken || window.optaAdminToken){
			this.getUserDetailsFromServer();
		} else {
			this.setState( {ajaxLoadingState : ''} );
		}
	}

	componentWillUnmount() {
	}

	camelCase(str){
		var retVal = "";
		for (var i=0; i< str.length; i++){
			var c = str.charAt(i).toLowerCase();
			if (i===0 || str.charAt(i-1) ===" ") c = c.toUpperCase();
			retVal += c;
		}
		retVal = retVal.replace(/bmw/gi, "BMW");
		return retVal;
	}

	preprocessAdminPayload(jsonO){
		//Admin payload
		jsonO["FirstName"] = jsonO["vin"];
		jsonO["LastName"] = "Administrator";		
		jsonO["VIN"] = "000000000000";
		jsonO["Make"] = this.camelCase(jsonO["oem"]);
		
		return jsonO;
	}
	
	preprocessServerResponse(jsonO){
		if (!jsonO["Key"]) return this.preprocessAdminPayload(jsonO);
		
		var userOem = jsonO["Key"];
		jsonO = jsonO["Value"] ? jsonO["Value"][0] : {};
		jsonO["useroem"] = userOem;

		//trim dates
		jsonO["PolicyExpiryDate"] = (""+jsonO["PolicyExpiryDate"]).split("T")[0];

		//trim long strings for userOEM
		if (jsonO["useroem"]==='Vw'){
			jsonO["LossPayee"] = this.camelCase(jsonO["Make"]);
			jsonO["AdditionalInsured"] = this.camelCase(jsonO["Make"]);
		} else {
			jsonO["LossPayee"] = this.camelCase((""+jsonO["LossPayee"]).split(" ")[0]);
			jsonO["AdditionalInsured"] = this.camelCase((""+jsonO["AdditionalInsured"]).split(" ")[0]);
		}

		//normalize names
		var l;
		var names;

		if (typeof jsonO["LesseeName"] ==="undefined") jsonO["LesseeName"] = "";
		jsonO["LesseeName"] = jsonO["LesseeName"].trim();
		if ( jsonO["LesseeName"].match(/,/)){
			names = jsonO["LesseeName"].split(",");
			l = names.length;
			jsonO["FirstName"] = this.camelCase(names[l-1].trim());
			jsonO["LastName"] = this.camelCase(names[0].trim());
		} else if (jsonO["LesseeName"].match(/ /)){
			names = jsonO["LesseeName"].split(" ");
			l = names.length;
			jsonO["FirstName"] = this.camelCase( (names[0]).trim());
			for (var i=1; i<(l-1); i++)
				jsonO["FirstName"] += " " + this.camelCase( names[i].trim());
			jsonO["LastName"] = this.camelCase( names[l-1].trim());
		} else {
			jsonO["FirstName"] = (""+jsonO["LesseeName"]);
			jsonO["LastName"] = "";
		}
		return jsonO;
	}

	getUserDetailsFromServer(){
		var t = this;
		var formData = new FormData();
		//console.log("getUserDetailsFromServer optaToken=" + window.optaToken);
		if (window.optaToken){
			formData.append( "optatoken", window.optaToken);
		} else if (window.optaAdminToken){
			formData.append( "optatoken", window.optaAdminToken);
		}

		var xhr = new XMLHttpRequest();
		xhr.onreadystatechange = function() {
			if (this.readyState === 4){
				t.setState({ ajaxLoadingState: "" });
				if (this.status === 200) {
					if (this.responseText){
						var responseJson = JSON.parse(this.responseText);
						//console.log(responseJson);
						var dbFields = t.preprocessServerResponse(responseJson);
						//console.log(" t = %o", t);
						t.setState({
							dbFields: dbFields,
							firstnameInputStatus : "ok",
							lastnameInputStatus : "ok",
							oemInputStatus : "ok",
							vinInputStatus : "ok",
						});
					}
					t.setState({ajaxLoadingState: ""});
				} else {
					t.setState( (prevState, props) => {
							return { dbFields: {}, ajaxLoadingState: "" };
					} );
				}
			}
		};

		xhr.open('post', window.AppConfig["url-lesseedetails"], true);
		try{
			this.setState({ ajaxLoadingState: "loading" });
			xhr.send(formData);
		} catch (e) {
			//console.log("Failed to get lessee details:" + e);
		}
	}

	generateUrl(pageName) {
		var url = pageName + "-" + window.locale + (window.optaToken ? "?oa=" + window.optaToken : "");
		return url;
	}

	dismissLightbox(){
		//console.log("dismissing lightbox");
		/*this.setState( (prevState, props) => {
			return { isLightboxVisible : false};
		} );*/
		window.location.href = this.generateUrl("contactus");
	}

	dispatchMessage(){
		var t = this;
		var formData = new FormData(document.getElementById("idContactUs"));
		formData.append( "optatoken", window.optaToken);

		var xhr = new XMLHttpRequest();
		xhr.onreadystatechange = function() {
			if (this.readyState === 4){
				if (this.status === 200) {
					t.setState( (prevState, props) => {
						return { isLightboxVisible : true, ajaxLoadingState: ""};
					});
				} else {
					t.setState({ ajaxLoadingState: ""});
					setTimeout( function(){
						//allow component state to set, to remove spinner
						alert(window.l10n[window.locale]["contactus.errormsg"]);
					}, 100);

				}
			}
		};

		xhr.open('post', window.AppConfig["url-contactus"], true);
		try{
			this.setState({ ajaxLoadingState: "loading"});
			xhr.send(formData);
		} catch (e) {
			this.setState({ ajaxLoadingState: ""});
			setTimeout( function(){
				//allow component state to set, to remove spinner
				alert(window.l10n[window.locale]["contactus.errormsg"] + "\n" + e);
			}, 100);
		}
	}

	manageEmailInput(e){
		//onChange handler
		var v = e.target.value.trim();
		this.setState({lesseeEmail : v});

		if (/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(v)){
			this.setState({emailInputStatus : "ok"});
		} else {
			this.setState({emailInputStatus : "invalid"});
		}
	}

	manageTelInput(e){
		var v = e.target.value;
		v = v.trim().replace(/-/g, '');

		var v1 = "";
		for (var i=0; i<v.length; i++){
			if ( i===3 || i===6 ) v1 = v1 + "-";
			v1 = v1 + v[i];
		}

		this.setState({lesseeTel : v1});

		var lesseeTel = e.target.value;
		//console.log("Lessee tel = " + lesseeTel);
		if (/^[1-9]\d{2}-\d{3}-\d{4}$/.test(lesseeTel)){
			this.setState( {telInputStatus : "ok"} );
		} else {
			this.setState( {telInputStatus : "invalid"} );
		}
	}

	validateEmailInput(e){
		//onKeyPress handler
		var k = e.key;
		if (!"abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!#$%&'*+-/=?^_`{|}~.@".match(k)){
			e.preventDefault();
			return false;
		}
		return true;
	}

	validateTelInput(e){
		var k = e.key;
		if (!"01234567890".match(k)){
			e.preventDefault();
			return false;
		}
		return true;
	}

	getSubmitButtonStatus(){
		var s = this.state.firstnameInputStatus +
			this.state.lastnameInputStatus +
			this.state.telInputStatus +
			this.state.emailInputStatus +
			this.state.oemInputStatus +
			this.state.vinInputStatus +
			this.state.messageInputStatus;
		if ( !/^(ok){7}$/.test(s) ){
			return "disabled";
		}
		return "";
	}

	render() {
		var lightbox = null;
		if (this.state.isLightboxVisible){
			lightbox=
				<div className="contactus-lightbox">
					<div className="dialog">
							<button className="close-btn" type="image" onClick={ (e)=>{this.dismissLightbox()} }/>
							<div className="title">{ window.l10n[window.locale]["contactus.title"] }</div>
							<div className="txt">{ window.l10n[window.locale]["contactus.text"] }</div>
					</div>
				</div>;
		}

		return(
		<div id="contactus-page">
			<div className={"ajax-spinner-lightbox " + this.state.ajaxLoadingState } />
			{ lightbox }
			<div className={"banner " + window.locale}/>
			<div className="txt1">
				{ window.l10n[window.locale]["contactus.contactus"] }
			</div>
			<div className="txt2">
				{ window.l10n[window.locale]["contactus.dropaline"] }
			</div>
			<div className="contactus-text">
				<div className="head1">{ window.l10n[window.locale]["contactus.getintouch"] }</div>
				<div className="head2">{ window.l10n[window.locale]["contactus.fillout"] }</div>
				<form id="idContactUs">
				<input type="text" name="firstname" id="contact-fn"
					placeholder={ window.l10n[window.locale]["contactus.firstname"] }
					value={ this.state.dbFields["FirstName"] ?  this.state.dbFields["FirstName"] : "" }
					onChange={ (e)=>{
						var dbf = this.state.dbFields;
						dbf["FirstName"] = e.target.value;
						this.setState({dbFields: dbf});

						if (e.target.value !== ""){
							this.setState( {firstnameInputStatus : "ok"} );
						} else {
							this.setState( {firstnameInputStatus : "invalid"} );
						}
					}}
					className = { this.state.firstnameInputStatus }
				/>
				<input type="text" name="lastname" id="contact-ln" placeholder={ window.l10n[window.locale]["contactus.lastname"] }
					value={ this.state.dbFields["LastName"] ? this.state.dbFields["LastName"] : "" }
					onChange={ (e)=>{
						var dbf = this.state.dbFields;
						dbf["LastName"] = e.target.value;
						this.setState({dbFields: dbf});

						if (e.target.value !== ""){
							this.setState( {lastnameInputStatus : "ok"} );
						} else {
							this.setState( {lastnameInputStatus : "invalid"} );
						}
					}}
					className = { this.state.lastnameInputStatus }
				/>
				<input id="contact-ph" name="telephone" type="tel" maxLength="12"
					onKeyPress={this.validateTelInput}
					onChange={this.manageTelInput}
					value={ this.state.lesseeTel }
					placeholder={ window.l10n[window.locale]["contactus.phonenumber"] }
					className = { this.state.telInputStatus }
				/>
				<input id="contact-em" name="email" type="email" maxLength="50"
					onKeyPress={this.validateEmailInput}
					onChange={this.manageEmailInput}
					value={ this.state.lesseeEmail }
					placeholder={ window.l10n[window.locale]["contactus.email"] }
					className = { this.state.emailInputStatus }
				/>
				<input type="text" name="oem" id="contact-mfg" placeholder={ window.l10n[window.locale]["contactus.manufacturer"] }
					value={ this.state.dbFields["Make"] ? this.state.dbFields["Make"] : ""}
					onChange={ (e)=>{
						var dbf = this.state.dbFields;
						dbf["Make"] = e.target.value;
						this.setState({dbFields: dbf});

						if (e.target.value !== ""){
							this.setState( {oemInputStatus : "ok"} );
						} else {
							this.setState( {oemInputStatus : "invalid"} );
						}
					}}
					className = { this.state.oemInputStatus }
				/>
				<input type="text" name="vin" id="contact-vin" placeholder={ window.l10n[window.locale]["contactus.vin"] }
					value={ this.state.dbFields["VIN"] ? this.state.dbFields["VIN"] : ""}
					onChange={ (e)=>{
						var dbf = this.state.dbFields;
						dbf["VIN"] = e.target.value;
						this.setState({dbFields: dbf});

						if (e.target.value.length > 11){
							this.setState( {vinInputStatus : "ok"} );
						} else {
							this.setState( {vinInputStatus : "invalid"} );
						}
					}}
					className = { this.state.vinInputStatus }
				/>
				<textarea name="message" id="contact-msg" maxLength="2000"
					placeholder={ window.l10n[window.locale]["contactus.msg"] }
					className = { this.state.messageInputStatus }
					onChange={ (e)=>{
						if (e.target.value !== ""){
							this.setState( {messageInputStatus : "ok"} );
						} else {
							this.setState( {messageInputStatus : "invalid"} );
						}
					}}
				>
				</textarea>
				<input type="button" id="contact-submit"
					value={ window.l10n[window.locale]["contactus.submit"] }
					disabled={this.getSubmitButtonStatus()===''? "" : "disabled"}
					onClick={(e)=>{
						if (this.getSubmitButtonStatus()!=='') return;
						//console.log("Submit btn clicked");
						this.dispatchMessage();
					}}

				/>
				</form>
			</div>
		</div>
		)
	}
}

export default ContactusPage;



// WEBPACK FOOTER //
// ./src/components/contactus-page.js